<template>
  <div>
    <v-card light>
     <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
     Formations de masse
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>     
 
       <v-btn
      dark
      absolute
      fixed
      bottom
      large
      right
      fab
      color="primary"
    
      class="mr-4 mb-16 fabNav"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
        light
          :headers="headers"
          :items="FormationsDeMasse"
          :search="search"
        ></v-data-table>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="AdminNavigation" v-if="isAdmin" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Formation", value: "ll_formation" },
        { text: "Participants", value: "nombre_participants" },
        { text: "Activité", value: "ll_parcours" },
        { text: "Date", value: "date_formation" },
        { text: "Responsable", value: "nom_responsable" },
        {
          text: "Région",
          value: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
        },
        {
          text: "Thème",
          value: "ll_theme",
        },
      ],
    };
  },
  created() {
    this.GetFormationsDeMasse();
  },
  methods: {
    ...mapActions({
      GetFormationsDeMasse: "FormationsDeMasse/GetAll",
    }),
  },
  computed: {
    ...mapState({
      FormationsDeMasse: (state) => state.FormationsDeMasse.FormationsDeMasse,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
       isAdmin: (state) => state.Auth.isAdmin,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
